import { Form, Select } from "antd";
import { LabeledField } from "../labeledField/labeledField";

const { Option } = Select;

export const AssociatedTitleField = ({
  jobTiers = [],
  form,
  disabled,
  isFormItem = true,
  extraLabel = null,
  style = {},
}) => {
  const shouldUpdate = (prevValues, currValues) => {
    if (prevValues.jobTiersId !== currValues.jobTiersId && form) {
      form.resetFields(["jobTiersTitlesId"]);
    }
    return prevValues.jobTiersId !== currValues.jobTiersId;
  };

  const renderField = (getFieldValue = () => null) => {
    const jobTierTitles =
      jobTiers
        .find(({ id }) => id === getFieldValue("jobTiersId"))
        ?.jobTierTitle?.sort((a, b) =>
          a.job_title.name.localeCompare(b.job_title.name),
        ) || [];

    return (
      <Select
        showSearch
        allowClear
        optionFilterProp="children"
        placeholder="Select Tier Associated Title"
        disabled={disabled || !getFieldValue("jobTiersId")}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        style={style}
      >
        {jobTierTitles.map(({ job_title }, index) => (
          <Option key={index} value={job_title.id}>
            {job_title.name}
          </Option>
        ))}
      </Select>
    );
  };

  if (isFormItem) {
    return (
      <Form.Item shouldUpdate={shouldUpdate}>
        {({ getFieldValue }) => (
          <Form.Item
            label="Associated Title"
            name="jobTiersTitlesId"
            className="mb-0"
            rules={[
              {
                required: true,
                message: "Please select tier associated title",
              },
            ]}
          >
            {renderField(getFieldValue)}
          </Form.Item>
        )}
      </Form.Item>
    );
  }

  return (
    <LabeledField label="Associated Title" required extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
};
